// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"0008adcb","220":"23902c00","420":"2602f0ab","830":"6734d73f","981":"8262b53a"}[chunkId] + ".chunk.css";
};